import { render } from "./nav-bar.html?vue&type=template&id=5ae506e5&ts=true"
import script from "./nav-bar.vue?vue&type=script&lang=ts"
export * from "./nav-bar.vue?vue&type=script&lang=ts"

import "./nav-bar.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\mt7rk\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__